"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLedger = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconLedger = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsx)("svg", _objectSpread(_objectSpread({
    width: "36",
    height: "40",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M3.65389 0C1.64498 0 0 1.63708 0 3.63633V31.8179C0 33.8171 1.64498 35.4542 3.65389 35.4542H18.3124L18.7263 39.19C18.7566 39.4688 18.9154 39.7174 19.1545 39.8647C19.3954 40.0121 19.6898 40.0405 19.9538 39.9428L23.6077 38.5792C23.8236 38.5011 24.002 38.3431 24.1073 38.1389L25.506 35.4543H27.4043C27.9092 35.4543 28.3178 35.0477 28.3178 34.5452V30.0992L35.5255 16.3212C35.7486 15.8844 35.5844 15.3517 35.1544 15.1138L31.0438 12.8411C30.8832 12.7506 30.6995 12.7115 30.5157 12.7275C30.2071 12.7541 29.9323 12.937 29.7878 13.2104L28.3176 15.9661V0.909414C28.3176 0.406919 27.9091 0.000331832 27.4042 0.000331832L3.65389 0ZM3.65389 1.81816H26.4907V5.45449H3.65389C2.67976 5.45449 1.90724 4.73186 1.82695 3.7926V3.63635C1.82695 2.61363 2.62623 1.81819 3.65389 1.81819V1.81816ZM1.82695 6.78994C2.36576 7.10243 2.98843 7.27289 3.65389 7.27289H4.56736V33.6363H3.65389C2.62623 33.6363 1.82695 32.8408 1.82695 31.8181V6.78994ZM6.39431 7.27289H16.4425V13.6365C16.4443 13.9596 16.6191 14.2579 16.901 14.4195C17.1847 14.5793 17.5308 14.5793 17.8127 14.4177L20.5531 12.8552L23.2936 14.4177C23.5755 14.5793 23.9216 14.5793 24.2053 14.4195C24.4871 14.2579 24.662 13.9596 24.6638 13.6365V7.27289H26.4907V19.375L18.8687 33.6363H6.39431V7.27289ZM18.2695 7.27289H22.8368V12.0597L21.0099 11.0228C20.728 10.8612 20.3783 10.8612 20.0964 11.0228L18.2695 12.0597V7.27289ZM30.9722 14.8865L33.4843 16.2643L32.4424 18.2671L29.9161 16.8608L30.9722 14.8865ZM29.0596 18.466L31.6002 19.8722L22.6368 37.003L20.4244 37.8268L20.1247 35.1848L29.0596 18.466ZM26.4905 33.5795V33.6363H26.4619L26.4905 33.5795Z",
      fill: color
    }, void 0)
  }), void 0);
});